﻿'use strict';

angular.module('ntmApp').factory('ListGridConditions', function () {

    function ListGridConditions(conditionObj) {

        var self = this;

        self.hasConditions = function () {
            return conditionObj ? true : false;
        };

        self.getRowTemplate = function () {
            conditionObj.value = conditionObj.type === 'Date' ? new Date(conditionObj.value).getTime() : conditionObj.value;
            return '<div ng-mouseover="rowStyle={\'background-color\': \'#FFFBEF\', \'cursor\': \'pointer\'}; grid.appScope.onRowHover(this);" ng-mouseleave="rowStyle={}" ng-class="{\'{0}\':row.entity[\'{1}_\'].getTime(){2}\'{3}\' }"><div ng-style="rowStyle" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"  ng-click="grid.appScope.selectRow(row)" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell></div></div>'.format(conditionObj.css, conditionObj.field, conditionObj.condition, conditionObj.value);
        };

    }

    return (ListGridConditions);
});